import { render, staticRenderFns } from "./WebsiteProductOptions.vue?vue&type=template&id=daa1c53a&"
import script from "./WebsiteProductOptions.vue?vue&type=script&lang=js&"
export * from "./WebsiteProductOptions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports